<template>
    <div class="t-work-area__row">
        <div class="t-work-area__column_big _only">
            <div class="t-work-area__cell t-curseCreate">
                <template>
                    <h2>{{ pageText.title }}</h2>

                    <div class="t-inputBox">
                        <div class="t-input" v-for="(item, index) in form" :key="index"
                                :class="[item.class, {'_error': item.error}]"
                                v-if="course.can_edit || (!course.can_edit && item.canEdit)">
                            <label>{{ item.label }}</label>

                            <input v-model="item.value" v-if="item.type === 'text'" :placeholder="item.placeholder"
                                @input="ClearError(index)">

                            <cmp-topics-select v-if="item.type === 'topics_select'"
                                            :value="item.value"
                                            :options="item.options"
                                            :name="item.name"
                                            :placeholder="item.placeholder"
                                            v-model="item.value"
                            ></cmp-topics-select>

                            <textarea-autosize v-if="item.type === 'textarea'" :placeholder="item.placeholder"
                                            v-model="item.value" :min-height="120"
                                            @input="ClearError(index)"></textarea-autosize>

                            <v-select v-if="item.type === 'select'"
                                    v-model="item.value"
                                    :options="item.options"
                                    :placeholder="item.placeholder"
                                    :searchable="false"
                                    :filterable="false"
                                    @input="ClearError(index)"></v-select>
                        </div>

                        <div class="t-input t-input_30" v-if="type.value !== 3 && course.can_edit">
                            <label>{{ lessons[0].duration.label }}</label>
                            <v-select v-model="lessons[0].duration.value"
                                    :options="lessons[0].duration.options"
                                    :placeholder="lessons[0].duration.placeholder"
                                    :searchable="false"
                                    :filterable="false"></v-select>
                        </div>
                    </div>

                    <template v-if="type.value === 3">
                        <h2>{{ pageText.lessonsTitle }}</h2>
                        <div class="t-lesson" v-for="(lesson, index) in lessons" :key="'lesson_' + index">
                            <h2>{{ index + 1 }}</h2>
                            <div class="t-inputBox t-inputBox_wrap">
                                <div v-for="(item, index_item) in lesson"
                                        v-if="item && (item.value != undefined)"
                                        :key="'lesson_input_' + index_item"
                                        class="t-input"
                                        :class="[ item.class, {'t-input_30': item.type === 'select'}]">
                                    <label>{{ item.label }}</label>

                                    <input v-model="item.value" v-if="item.type === 'text'" :placeholder="item.placeholder">

                                    <textarea-autosize v-if="item.type === 'textarea'" :placeholder="item.placeholder"
                                                    v-model="item.value" :min-height="80"></textarea-autosize>

                                    <v-select v-if="item.type === 'select'"
                                            v-model="item.value"
                                            :options="item.options"
                                            :placeholder="item.placeholder"
                                            :searchable="false"
                                            :filterable="false"></v-select>
                                </div>
                            </div>
                        </div>
                    </template>
                </template>

                <h2>{{ pageText.calendar }}</h2>
                <cmp-calendar :lesson_type="type.value" :lessons="lessons" :lesson_index="lesson_index"
                            :course="course" ></cmp-calendar>
                <div class="t-input_buttons t-curseCreate__buttons" v-if="!course.isHidden">
                    <button class="t-btn" @click.prevent="UpdateCourse('')" :disabled="!canEdit">
                        <span>{{ pageText.saveBtn }}</span></button>
                    <router-link :to="{name: 'courses_info'}" class="t-btn t-btn_white">
                        <span>{{ pageText.closeBtn }}</span></router-link>
                    <button class="t-btn t-btn_white" @click.prevent="okModalOpen('unpublished')">
                        <span>{{ pageText.unpublishedBtn }}</span></button>
                    <button class="t-btn t-btn_white" @click.prevent="okModalOpen('delete')"><span>{{ pageText.deleteBtn }}</span>
                    </button>
                </div>
                <div class="t-input_buttons t-curseCreate__buttons" v-else>
                    <button class="t-btn" @click.prevent="UpdateCourse('/published')">
                        <span>{{ pageText.publishedBtn }}</span></button>
                    <button class="t-btn  t-btn_white" @click.prevent="UpdateCourse('/inedited')" :disabled="!canEdit">
                        <span>{{ pageText.ineditedBtn }}</span>
                    </button>
                    <router-link :to="{name: 'courses_info'}" class="t-btn t-btn_white">
                        <span>{{ pageText.closeBtn }}</span></router-link>
                    <button class="t-btn t-btn_white" @click.prevent="okModalOpen('delete')"><span>{{ pageText.deleteBtn }}</span>
                    </button>
                </div>
                <div class="t-curseCreate__error" v-if="lessons_error">
                    {{ pageText.error }}
                </div>
            </div>
        </div>
        <transition name="fade">
            <form class="t-unpublishedModal" v-show="okModal!==''" @submit.prevent="okModalSubmit()">
                <span class="t-unpublishedModal__close" @click.prevent="okModalClose()"></span>
                <h2>{{ pageText.unpublishedModalTitle }}</h2>
                <h3>{{ pageText.unpublishedModalSubTitle }}</h3>
                <button class="t-btn t-unpublishedModal__btn"><span>{{ pageText.unpublishedModalBtn }}</span></button>
                <button class="t-btn t-btn_white" type="button" @click.prevent="okModalClose()"><span>{{ pageText.unpublishedModalBtnCancel }}</span></button>
            </form>
        </transition>
        <!--<div class="t-work-area__column_small _min"></div>-->
    </div>
</template>

<script>
    let localeText = {
        url: process.env.NODE_ENV !== 'production' ? 'staticText/courseEdit.json' : 'staticText',
        main: {
            title: "Описание вашего занятия",
            lessonsTitle: "Уроки курса",
            calendar: "Расписание",
            saveBtn: "Сохранить изменения",
            closeBtn: "Закрыть без изменений",
            unpublishedBtn: "Снять с публикации",
            deleteBtn: "Удалить урок",
            publishedBtn: "Сохранить и опубликовать",
            ineditedBtn: "Сохранить без публикации",
            error: "Необходимо расставить занятия по дням",
            type: ["Урок", "Консультация", "Курс"],
            formName: "Название",
            formTopics: "Выберите темы",
            formVideo: "Видео",
            formVideoPlaceholder: "Youtube или Vimeo",
            formDescription: "Описание",
            formPrice: "Цена",
            formPricePlaceholder: "Например 700",
            formStudents: "Максимальное число слушателей",
            formStudentsPlaceholder: "от 1 до 10",
            formDuration: "Продолжительность",
            formNameLesson: "Название",
            formNameLessonPlaceholder: "Введите название урока",
            formDescriptionLesson: "Описание урока",
            formDescriptionLessonPlaceholder: "Короткое описание урока",
            msgAllLessonsAdd: "Все уроки по курсу добавлены",
            msgLimitEnd: "Лимит на добавление дат исчерпан",
            msgCanSaveCourse1: "Добавьте все занятия. Добавлено только",
            msgCanSaveCourse2: " из ",
            msgUnpublished: "Курс снят с публикации",
            msgUpdate: "Урок обновлен",
            msgDelete: "Курс удален",
            msgPressSaveBtn: "Чтобы все изменения вступили в силу, нажмите «Сохранить изменения»",
            unpublishedModalTitle: "Внимание!",
            unpublishedModalSubTitle:"Изменение статуса урока приведет к автоматической отмене всех действующих заявок и возврат средств по ним. Продолжить?",
            unpublishedModalBtn: "Да",
            unpublishedModalBtnCancel: "Нет"
        }
    };

    import {store} from '../../../store'

    import TopicsSelect from '../../../vue_components/TopicsSelect.vue'
    import MultiSelect from '../../../vue_components/MultiSelect.vue'
    import Calendar from '../../../vue_components/Calendar/Calendar.vue'

    import {mapActions, mapGetters} from 'vuex';

    export default {
        computed: {
            ...mapGetters('coursesList', ['course', 'streams']),
            ...mapGetters('calendar', ['date_active', 'calendarTypeValue', 'day_week_header']),
            streamCurrentIndex(){
                let maxIndex = parseInt(this.course.flowLastId); 

                let maxLocalIndex = maxIndex; 

                let localIndexes = [];
                this.lessons[this.lesson_index].date_time.forEach(item => {
                    if (maxIndex < item.streamId)
                        maxIndex = item.streamId
                    if (maxLocalIndex < item.localStreamIndex)
                        maxLocalIndex = item.localStreamIndex
                    if (item.localStreamIndex && localIndexes.indexOf(item.localStreamIndex) < 0) {
                        localIndexes.push(item.localStreamIndex)
                    }
                });

                let currentIndex = maxLocalIndex + 1;

                if (this.lesson_index > 0) {
                    // currentIndex = maxLocalIndex + 1;
                    currentIndex = this.lessons[this.lesson_index-1].date_time[this.lessons[this.lesson_index-1].date_time.length -1].localStreamIndex
                } else {
                    localIndexes = localIndexes.sort();
                    localIndexes.forEach(item => {
                        if (item == currentIndex) {
                            currentIndex = item + 1 
                        }
                    });
                }

                return currentIndex 
            },
            maxStreamLocalIndex(){
                let maxIndex = -1; 
                this.lessons[this.lesson_index].date_time.forEach(item => {
                    if (maxIndex < item.streamId)
                        maxIndex = item.streamId
                    if (maxIndex < item.localStreamIndex)
                        maxIndex = item.localStreamIndex
                });
                return maxIndex
            }
        },
        components: {
            'cmp-topics-select': TopicsSelect,
            'cmp-calendar': Calendar
        },
        created() {
            for (let key in this.form) {
                this.form[key].value = this.course[key];
            }
        },
        data() {
            return {
                pageText: {},

                okModal: '',

                maxDate: 60,
                lesson_index: 0,
                lessons_error: false,
                canEdit: false,
                type: {
                    value: 1,
                    items: [
                        {
                            value: 1,
                            title: ''
                        },
                        {
                            value: 2,
                            title: ''
                        },
                        {
                            value: 3,
                            title: ''
                        }
                    ]
                },
                form: {
                    name: {
                        type: 'text',
                        label: '',
                        name: 'name',
                        full: true,
                        class: 't-input_full',
                        error: false,
                        required: true,
                        canEdit: true,
                        value: '',
                        placeholder: ''
                    },
                    topics: {
                        type: 'topics_select',
                        label: '',
                        name: 'topics',
                        full: false,
                        class: 't-input_70',
                        error: false,
                        required: false,
                        canEdit: true,
                        disabled: false,
                        value: [],
                        options: store.getters['handbook/topics'],
                        placeholder: ''
                    },
                    video: {
                        type: 'text',
                        label: '',
                        name: 'video',
                        full: false,
                        class: 't-input_30',
                        error: false,
                        required: false,
                        canEdit: true,
                        value: '',
                        placeholder: ''
                    },
                    text: {
                        type: 'textarea',
                        label: '',
                        name: 'text',
                        full: true,
                        class: 't-input_full',
                        error: false,
                        required: true,
                        canEdit: true,
                        value: '',
                        placeholder: ''
                    },
                    price: {
                        type: 'text',
                        label: '',
                        name: 'price',
                        full: false,
                        class: 't-input_30',
                        error: false,
                        required: true,
                        canEdit: false,
                        value: '',
                        placeholder: ''
                    },
                    students: {
                        type: 'select',
                        label: '',
                        name: 'students',
                        full: false,
                        class: 't-input_30',
                        error: false,
                        required: true,
                        canEdit: false,
                        value: '',
                        options: store.getters['handbook/listeners'],
                        placeholder: ''
                    }
                },
                oldState: null,
                oldStateLessons: null,
                lessons: [
                    {
                        date_time: [],
                        lessonName: {
                            type: 'text',
                            label: 'Название урока',
                            name: 'lessonName',
                            full: true,
                            class: 't-input_70',
                            error: false,
                            required: true,
                            value: '',
                            placeholder: ''
                        },
                        duration: {
                            type: 'select',
                            label: '',
                            name: 'duration',
                            full: false,
                            error: false,
                            required: true,
                            value: store.getters['handbook/duration'][0],
                            options: store.getters['handbook/duration'],
                            placeholder: ''
                        },
                        text: {
                            type: 'textarea',
                            label: '',
                            name: 'text',
                            full: true,
                            class: 't-input_full',
                            error: false,
                            required: true,
                            value: '',
                            placeholder: ''
                        },
                        id: null
                    }
                ],
                deleteLessons: [],
                deleteStreams: [],
                updateLessons: []
            }
        },
        methods: {
            ...mapActions(['UpdatePreloadState']),
            ...mapActions('msg', ['showMsg']),
            okModalClose(){
                this.okModal = '';
            },
            okModalOpen(name){
                this.okModal = name;
            },
            okModalSubmit(){
                if (this.okModal == 'unpublished') {
                    this.Unpublished();
                } else if (this.okModal == 'delete') {
                    this.Delete();
                }
                this.okModalClose();
            },
            // setEditableSave() {
            //     this.canEdit = true;
            // },
            DelLesson(lesson_index, index) {
                // this.canEdit = true;
                for (let u = 0; u < this.updateLessons.length; u++) {
                    if (this.updateLessons[u].id === this.lessons[lesson_index].date_time[index].id) {
                        this.updateLessons.splice(u, 1);
                    }
                }

                if (this.lessons[lesson_index].date_time[index] && this.lessons[lesson_index].date_time[index].id !== undefined)
                    this.deleteLessons.push(this.lessons[lesson_index].date_time[index].id);

                this.lessons[lesson_index].date_time.splice(index, 1);
                this.maxDate++;
                this.showMsg(this.pageText.msgPressSaveBtn);
            },
            DelCourseStream(streamId) {
                if ( this.lessons[0].date_time[streamId] && this.lessons[0].date_time[streamId].streamId !== undefined){
                    this.deleteStreams.push(this.lessons[0].date_time[streamId].streamId);
                    this.lessons.forEach(item => {
                        item.date_time.splice(streamId, 1);
                        item.date_time.forEach( (item, index) => {
                            if (index >= streamId)
                                item.localStreamIndex--;
                        })
                        this.maxDate++;
                    });
                } else {
                    this.lessons.forEach(item => {
                        item.date_time.splice(streamId, 1);                        
                        item.date_time.forEach( (item, index) => {
                            if (index >= streamId)
                                item.localStreamIndex--;
                        })
                        this.maxDate++;
                    });
                }
                
                // если удаляем курс в который не закончили ставить все уроки
                if (streamId == this.streamCurrentIndex) {
                    // то сбросить счетчик индекса урока 
                    this.lesson_index =0;
                }

                this.showMsg(this.pageText.msgPressSaveBtn);
            },
            AddDate(data) {
                // this.canEdit = true;
                if (this.maxDate > 0) {

                    this.lessons[this.lesson_index].date_time.push({
                        date: data,
                        update: false,
                        // localStreamIndex: this.maxStreamLocalIndex + 1,
                        localStreamIndex: this.streamCurrentIndex ,
                        changed: false
                    });
                    this.lessons_error = false;

                    this.maxDate--;

                    if (this.type.value === 3) {
                        // ? возможно этот код уже не нужен
                        this.lesson_index++;
                        if (this.lesson_index >= this.lessons.length) {
                            this.lesson_index = 0;
                            this.showMsg(this.pageText.msgAllLessonsAdd)
                        }
                    }

                    this.showMsg(this.pageText.msgPressSaveBtn);
                } else {
                    this.showMsg(this.pageText.msgLimitEnd)
                }
            },
            UpdateDate(lesson_index, data, editCourse) {
                for (let i = 0; i < data.length; i++) {
                    let date = data[i].date || data[i];
                    let time = date.getHours() + ':' + date.getMinutes();

                    let time_old = this.lessons[lesson_index].date_time[data[i].index].date.getHours() + ':' + this.lessons[lesson_index].date_time[data[i].index].date.getMinutes();

                    if (time_old !== time || editCourse) {

                        this.lessons[lesson_index].date_time.splice(data[i].index, 1, {
                            date: date,
                            update: false,
                            id: this.lessons[lesson_index].date_time[data[i].index].id,

                            streamId: this.lessons[lesson_index].date_time[data[i].index].streamId,
                            localStreamIndex: this.lessons[lesson_index].date_time[data[i].index].localStreamIndex,
                            changed: false
                        });

                        let push = true;

                        for (let u = 0; u < this.updateLessons.length; u++) {
                            if (this.lessons[lesson_index].date_time[data[i].index].id && this.updateLessons[u].id === this.lessons[lesson_index].date_time[data[i].index].id ) {
                                // console.log('edit time', this.updateLessons[u].id)
                                push = false;
                                this.updateLessons[u].date = data[i].date;
                                break;
                            }
                        }


                        if (push) {
                            let id = this.lessons[lesson_index].date_time[data[i].index].id;
                            if (id)
                                this.updateLessons.push({
                                    id: id,
                                    date: data[i].date.toLocaleString("en", { hour12: false })
                                });
                        }
                    }
                }

                this.showMsg(this.pageText.msgPressSaveBtn);
            },
            UpdateDateById(data, editCourse) {

                let lesson = undefined;
                let lesson_index = data.lesson_index;

                let date = data.date || data;

                for (let i = 0; i < this.lessons[lesson_index].date_time.length; i++) {
                    let item = this.lessons[lesson_index].date_time[i];
                    if (item.id === data.id) {
                        lesson = item
                        this.lessons[lesson_index].date_time.splice(i, 1, {
                            date: date,
                            update: item.update,
                            id: item.id,
                            streamId: item.streamId,
                            localStreamIndex: item.localStreamIndex,
                            changed: item.changed
                        });
                        
                        let push = true;
                        for (let u = 0; u < this.updateLessons.length; u++) {
                            if (item.id && this.updateLessons[u].id === item.id ) {
                                push = false;
                                this.updateLessons[u].date = date;
                                break;
                            }
                        }

                        if (push) {
                            let id = item.id;
                            if (id)
                                this.updateLessons.push({
                                    id: id,
                                    date: date.toLocaleString("en", { hour12: false })
                                });
                        }
                        break;
                    }
                }

                this.showMsg(this.pageText.msgPressSaveBtn);
            },
            ClearError(key) {
                if (this.form[key].name === 'price') {
                    this.form[key].value = this.form[key].value.replace(/[^\d,.]/g, "");
                }

                this.form[key].error = false;
            },
            Unpublished() {
                this.$http.put('course/' + this.course.id + '/unpublished')
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            // this.$router.go();
                            store.dispatch('coursesList/LoadCourse', this.$router.currentRoute.params).then((e) => {});
                            this.showMsg(this.pageText.msgUnpublished)
                        } else {
                            this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                        }
                    })
                    .catch(error => {
                        this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                    });
            },
            UpdateCourse(publish) {
                let valid = true;

                for (let key in this.form) {
                    if (this.form[key].required) {
                        switch (typeof this.form[key].value) {
                            case 'string':
                                if (this.form[key].value === '') {
                                    valid = false;
                                    this.form[key].error = true;
                                }
                                break;
                            case 'object':
                                if (!this.form[key].value.length) {
                                    valid = false;
                                    this.form[key].error = true;
                                }
                                break;
                            case 'number':
                                if (this.form[key].value <= 0) {
                                    valid = false;
                                    this.form[key].error = true;
                                }
                                break;
                            default:
                                break;
                        }
                    }
                }

                if (this.form.video.value !== '') {
                    if (this.form.video.value.indexOf('youtube') < 0 || this.form.video.value.indexOf('youtu.be') >= 0) {
                        if (this.form.video.value.indexOf('vimeo') < 0) {
                            this.form.video.error = true;
                        }
                    }
                }

                for (let i = 0; i < this.lessons.length; i++) {
                    if (this.lessons[i].date_time === '') {
                        this.lessons_error = true;
                        valid = false;
                    }
                }

                if (this.course.type == 3){
                    let min = 0;
                    for (let i = 0; i < this.lessons.length; i++) {
                        min = this.lessons[i].date_time.length>min?this.lessons[i].date_time.length: min
                        if (this.lessons[i].date_time.length < min ) {
                            // this.lessons_error = true;
                            let str = this.pageText.msgCanSaveCourse1 + ' ' + i + this.pageText.msgCanSaveCourse2 + this.lessons.length ;
                            this.showMsg(str)
                            valid = false;
                            break;
                        }
                    }
                }


                if (valid || this.course.isHidden) {
                    let fd = new FormData();

                    fd.append('type', this.course.type);
                    fd.append('name', this.form.name.value);

                    for (let i = 0; i < this.form.topics.value.length; i++) {
                        if (typeof this.form.topics.value[i].value == "string") {
                            fd.append('topics_new[]', '{"parent_id":"'+ this.form.topics.value[i].value.split('-')[0] + '", "name":"'+ this.form.topics.value[i].label + '"}');
                        } else {
                            fd.append('topics[]', this.form.topics.value[i].value);
                        }
                    }

                    if (this.form.video.value !== '')
                        fd.append('video', this.form.video.value);

                    fd.append('text', this.form.text.value);
                    fd.append('price', this.form.price.value);
                    fd.append('students', this.form.students.value);

                    for (let i = 0; i < this.lessons.length; i++) {
                        let append = false;

                        let lesson = {
                            duration: this.lessons[i].duration.value.value,
                            items: [],
                            lessonId: this.lessons[i].id
                        };

                        if (this.lessons[i].id === null) {
                            
                            if ( this.course.lessons){
                                lesson.lessonId = this.course.lessons[0].id;
                            } else {
                                lesson.lessonId = this.course.id;
                            }
                        }

                        if (this.type.value === 3) {
                            lesson.text= this.lessons[i].text.value
                            lesson.lessonName = this.lessons[i].lessonName.value
                        }

                        for (let j = 0; j < this.lessons[i].date_time.length; j++) {

                            console.log(this.lessons[i])
                            if (!this.lessons[i].date_time[j].id) {
                                // append = true;
                                let day = this.lessons[i].date_time[j].date.toLocaleString("en-US", { hour12: false }).split(', ')[0]
                                let time = this.lessons[i].date_time[j].date.toLocaleString("ru-RU", { hour12: false }).split(', ')[1]                                
                                // lesson.items.push(this.lessons[i].date_time[j].date.toLocaleString("en", { hour12: false }));
                                lesson.items.push(''+day+', '+time)
                            }
                        }

                        lesson = JSON.stringify(lesson);
                        // if (append) {
                            fd.append('newLessons[]', lesson);
                        // } 
                    }
                    for (let i = 0; i < this.deleteLessons.length; i++) {
                        fd.append('deleteLessons[]', this.deleteLessons[i]);
                    }

                    for (let i = 0; i < this.deleteStreams.length; i++) {
                        fd.append('deleteStreams[]', this.deleteStreams[i]);
                    }

                    for (let i = 0; i < this.updateLessons.length; i++) {
                        let lesson = JSON.stringify(this.updateLessons[i]);
                        fd.append('updateLessons[]', lesson);
                    }

                    let url = 'course/' + this.course.id + publish;

                    this.$http.put(url, fd)
                        .then(response => response.json())
                        .then(data => {
                            if (data.success) {
                                this.canEdit = false;
                                this.$router.push({name: 'courses_info', params: {id: this.course.id, slug: this.course.slug}});
                                store.dispatch('coursesList/LoadCourse', this.$router.currentRoute.params).then((e) => {});
                                this.showMsg(this.pageText.msgUpdate)
                                //this.$router.push({name: 'courses_info'});
                            } else {
                                this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                            }
                        })
                        .catch(error => {
                            this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                        });
                }
            },
            Delete() {
                this.$http.delete('course/' + this.course.id)
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            this.$router.push({name: 'my_courses'});

                            this.showMsg(this.pageText.msgDelete)
                        } else {
                            this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                        }
                    })
                    .catch(error => {
                        this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                    });
            },
            LoadStreams(){
                this.lessons.forEach((lesson, lesson_index) => {
                    // lesson.date_time.forEach( (data_time, data_index) => {
                    //     // if ( !data_time.changed ){
                    //     //     this.lessons[lesson_index].date_time.splice(data_index, 1);
                    //     // }
                    //     if ( data_time.id ){
                    //         this.lessons[lesson_index].date_time.splice(data_index, 1);
                    //     }
                    // });
                    let test = lesson.date_time.filter( (data_time ) => {
                        // data_time.id > 0
                        
                        return data_time.id == undefined || data_time.changed
                    });
                    lesson.date_time= test
                });
                // this.lessons[i].date_time[j]

                // this.lessons = []


                for (let s = 0; s < this.streams.length; s++) {
                    let stream = this.streams[s];

                    let streamPush = true;
                    this.deleteStreams.forEach((deleteStream) => {
                        if (deleteStream === stream.id) {
                            streamPush = false;
                        }
                    });
                    if (streamPush){
                        for (let l = 0; l < stream.lessons.length; l++) {
                            let lesson = stream.lessons[l];

                            for (let d = 0; d < store.getters['handbook/duration'].length; d++) {
                                if (store.getters['handbook/duration'][d].minute === lesson.duration) {
                                    this.lessons[l].duration.value = store.getters['handbook/duration'][d];
                                    break;
                                }
                            }
                            let updateDate = undefined;
                            this.updateLessons.forEach((updateLesson) => {
                                if (updateLesson.id === lesson.id) {
                                    updateDate = updateLesson.date;
                                }
                            });
                            this.lessons[l].date_time.push({
                                date: updateDate != undefined ? new Date(updateDate):new Date(lesson.date_time),
                                update: stream.applications.new === 0 && stream.applications.confirmed === 0,
                                id: lesson.id, 
                                changed: false,
                                streamId: stream.id
                            })
                        }
                    }
                }
            },
            load(pageText) {
                this.pageText = pageText;

                for (let i = 0; i < this.type.items.length; i++) {
                    this.type.items[i].title = pageText.type[i]
                }

                this.form.name.label = pageText.formName;
                this.form.topics.label = pageText.formTopics;
                this.form.video.label = pageText.formVideo;
                this.form.video.placeholder = pageText.formVideoPlaceholder;
                this.form.text.label = pageText.formDescription;
                this.form.price.label = pageText.formPrice;
                this.form.price.placeholder = pageText.formPricePlaceholder;
                this.form.students.label = pageText.formStudents;
                this.form.students.placeholder = pageText.formStudentsPlaceholder;

                this.lessons[0].duration.label = pageText.formDuration;
                // this.lessons[0].duration.value = store.getters['handbook/duration'][this.course.duration / 30 - 1];
                let val = store.getters['handbook/duration'][this.course.duration / 30 - 1];
                this.$set(this.lessons[0].duration, 'value', val)

                this.lessons[0].text.label = pageText.formDescriptionLesson;
                this.lessons[0].text.placeholder = pageText.formDescriptionLessonPlaceholder;

                this.type.value = this.course.type;

                if (this.course.type == 3){

                    let lesson = this.course.lessons[0];
                    this.lessons[0].lessonName.value = lesson.lessonName || '';
                    this.lessons[0].text.value = lesson.text || ''; 
                    this.lessons[0].lessonName.placeholder = this.pageText.formNameLessonPlaceholder

                    this.lessons[0].id = lesson.id;
                    for (let l = 1; l < this.course.lessons.length; l++) {
                        lesson = this.course.lessons[l];
                        this.lessons.push({
                            date_time: [],
                            lessonName: {
                                type: 'text',
                                label: this.pageText.formNameLesson,
                                name: 'lessonName',
                                full: true,
                                class: 't-input_70',
                                error: false,
                                required: true,
                                value: lesson.lessonName || '',
                                placeholder: this.pageText.formNameLessonPlaceholder
                            },
                            duration: {
                                type: 'select',
                                label: pageText.formDuration,
                                name: 'duration',
                                full: false,
                                error: false,
                                required: true,
                                value: store.getters['handbook/duration'][0],
                                options: store.getters['handbook/duration'],
                                placeholder: ''
                            },
                            text: {
                                type: 'textarea',
                                label: pageText.formDescriptionLesson,
                                name: 'text',
                                full: true,
                                error: false,
                                required: true,
                                value: lesson.text || '',
                                placeholder: pageText.formDescriptionLessonPlaceholder
                            },
                            id: lesson.id
                                })
                            // }

                            // this.lessons[l].lessonName.value = lesson.lessonName;
                            // this.lessons[l].text.value = lesson.text;
                            // this.lessons[l].id = lesson.id;

                    }
                }
                
                for (let s = 0; s < this.streams.length; s++) {
                    let stream = this.streams[s];
                    for (let l = 0; l < stream.lessons.length; l++) {
                        let lesson = stream.lessons[l];

                        for (let d = 0; d < store.getters['handbook/duration'].length; d++) {
                            if (store.getters['handbook/duration'][d].minute === lesson.duration) {
                                this.lessons[l].duration.value = store.getters['handbook/duration'][d];
                                break;
                            }
                        }
                        // console.log(stream )
                        // console.log(lesson )
                        this.lessons[l].date_time.push({
                            date: new Date(lesson.date_time),
                            update: stream.applications.new === 0 && stream.applications.confirmed === 0,
                            changed: false,
                            // streamId: lesson.streamId 
                            id: lesson.id,
                            streamId: stream.id
                        })
                    }
                }

                setTimeout(() => {
                    this.UpdatePreloadState(false);
                }, 500)
            },
            // LoadDate(date){
            //     for (let s = 0; s < this.streams.length; s++) {
            //         let stream = this.streams[s];
            //         for (let l = 0; l < stream.lessons.length; l++) {
            //             let lesson = stream.lessons[l];

            //             for (let d = 0; d < store.getters['handbook/duration'].length; d++) {
            //                 if (store.getters['handbook/duration'][d].minute === lesson.duration) {
            //                     this.lessons[l].duration.value = store.getters['handbook/duration'][d];
            //                     break;
            //                 }
            //             }

            //             this.lessons[l].date_time.push({
            //                 date: new Date(lesson.date_time),
            //                 update: stream.applications.new === 0 && stream.applications.confirmed === 0,
            //                 id: lesson.id,
            //                 changed: false
            //             })
            //         }
            //     }

            // }
        },
        watch: {
            date_active() {
                let start, end;

                if (this.calendarTypeValue.value === 1) {
                    start = this.date_active.getFullYear() + '.' + (this.date_active.getMonth() + 1) + '.1';
                    end = this.date_active.getFullYear() + '.' + (this.date_active.getMonth() + 1) + '.' + this.date_active.daysInMonth();
                } else {
                    let m = this.day_week_header[0].value;
                    let s = this.day_week_header[this.day_week_header.length - 1].value;

                    start = m.getFullYear() + '.' + (m.getMonth() + 1) + '.' + m.getDate();
                    end = s.getFullYear() + '.' + (s.getMonth() + 1) + '.' + s.getDate();
                }
                
                store.dispatch('coursesList/LoadStreamsMy', {start: start, end: end, notId: this.$router.currentRoute.params.id}).then(() => {
                });
                store.dispatch('coursesList/LoadStreamsEntries', {start: start, end: end}).then(() => {
                });
                store.dispatch('coursesList/LoadStreams', {start: start, end: end, id: this.$router.currentRoute.params.id}).then(() => {
                    this.LoadStreams();
                });
            },
            form: {
                handler: function (after, before) {
                    if (!this.oldState) {
                        this.oldState = {};
                        Object.keys(after).map((item) => {
                            if (!Array.isArray(after[item]['value'])) {
                                this.oldState[item] = after[item]['value'];
                            } else {
                                if (!this.oldState[item]) {
                                    this.oldState[item] = {};
                                }
                                Object.keys(after[item]['value']).map((pos) => {
                                    this.oldState[item][pos] = after[item]['value'][pos]['value'];
                                });
                            }
                        });
                    }

                    let total = Object.keys(after).filter((item) => {
                        if (typeof item === "string") {
                            if (!Array.isArray(after[item]['value'])) {
                                return this.oldState[item] != after[item]['value'];
                            } else {
                                if( Object.keys(this.oldState[item]).length != after[item]['value'].length){
                                    return true
                                }
                                let fl = after[item]['value'].filter((i, ix) => {
                                    return this.oldState[item][ix] != after[item]['value'][ix]["value"];
                                });
                                return fl.length >= 1;
                            }
                        }
                    });

                    this.canEdit = total.length >= 1;
                },
                deep: true,
            },
            lessons: {
                handler: function (after, before) {
                    if (!this.oldStateLessons) {
                        this.oldStateLessons = {};
                        let test = []

                        Object.keys(after).map((item) => {
                            let testItem ={}
                                
                            testItem.duration = after[item].duration.value.value;
                            testItem.lessonName = after[item].lessonName.value;
                            testItem.text = after[item].text.value;
                            testItem.id = after[item].id;
                            testItem.date_time = [];
                            after[item].date_time.forEach((item) => {
                                testItem.date_time.push(item)
                            });
                            test.push(testItem);
                        });
                        this.oldStateLessons = test
                    }
                    let total = Object.keys(after).filter((item) => {
                        if (typeof item === "string") {
                            let test = false;
                            if( this.oldStateLessons[item].date_time.length != after[item].date_time.length){
                                test = true
                            } else {
                                let fl = after[item].date_time.filter((i, ix) => {
                                    return this.oldStateLessons[item].date_time[ix] != after[item].date_time[ix];
                                });
                                test = fl.length >= 1;
                            }
                            return ((this.oldStateLessons[item].duration != after[item].duration.value.value) ||
                                (this.oldStateLessons[item].lessonName != after[item].lessonName.value) ||
                                (this.oldStateLessons[item].text != after[item].text.value) ||
                                test ) 
                        }
                    });
                    this.canEdit = total.length >= 1;
                },
                deep: true,
            }
        },
        beforeRouteLeave(to, from, next) {
            this.UpdatePreloadState(true);
            next();
        },
        beforeRouteEnter(to, from, next) {
            if (!store.getters['coursesList/course'].belonging) {
                next({name: 'courses_info', params: {id: to.params.id}});
            }

            let count = 0;

            let date = new Date();

            let start = date.getFullYear() + '.' + (date.getMonth() + 1) + '.1';
            let end = date.getFullYear() + '.' + (date.getMonth() + 1) + '.' + date.daysInMonth();
            store.dispatch('calendar/GoToday');

            let pageText = {};

            store.dispatch('staticText/LoadPageText', localeText).then((data) => {
                pageText = data;
                count++;
                RunNext();
            });

            store.dispatch('calendar/LoadCalendarText').then(() => {
                count++;
                RunNext();
            });

            store.dispatch('handbook/LoadTopics').then(() => {
                count++;
                RunNext();
            });

            store.dispatch('handbook/LoadListeners').then(() => {
                count++;
                RunNext();
            });
            store.dispatch('handbook/LoadDuration').then(() => {
                count++;
                RunNext();
            });
            store.dispatch('coursesList/LoadStreamsMy', {start: start, end: end, notId: to.params.id}).then(() => {
                count++;
                RunNext();
            });
            store.dispatch('coursesList/LoadStreamsEntries', {start: start, end: end}).then(() => {
                count++;
                RunNext();
            });
            store.dispatch('coursesList/LoadStreams', {start: start, end: end, id: to.params.id}).then(() => {
                count++;
                RunNext();
            });

            let RunNext = () => {
                if (count > 7)
                    next(vm => vm.load(pageText))
            }
        }
    }
</script>


<style lang="sass">
.t-unpublishedModal
    position: fixed
    z-index: 15
    right: 0
    left: 0
    width: 520px
    max-width: 90vw
    margin: auto
    @extend %substrate
    padding: 16px
    &__close
        position: absolute
        top: 12px
        right: 16px
        width: 40px
        height: 40px
        cursor: pointer
        background: url('/img/close.png') no-repeat center
    &__btn 
        margin-right: 16px
    h2
        color: $blue
        margin-bottom: 18px
    h3
        margin-bottom: 18px

</style>


// WEBPACK FOOTER //
// src/vue_pages/Courses/View/Edit.vue